import React, { Component } from "react";
import FilterSearchText from "./FilterSearchText";
import "./TableHeader.css";
import tableSort from "../images/tablesort.svg";

export default class TableHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [],
      filters: {},
    };
  }

  filter = (fObj1, fObj2) => {
    this.props.filters(fObj1, fObj2);
  };
  tableSort = (name) => {
    this.props.tableSort(name);
  };

  componentDidMount() {
    this.setState({
      headers: this.props.headers.map((item) => {
        return (
          <th
            className="headerTextColor"
            key={item.title}
            style={item.display ? { background: "#FFF" } : { display: "none" }}
          >
            {item.displayName}
            <img
              src={tableSort}
              style={{ cursor: "pointer" }}
              onClick={() => this.tableSort(item.title)}
            />
            {this.props.filtertext === "ClaimsTable" && (
              <div className="mt-1">
                <FilterSearchText
                  setFields={this.props.setFields}
                  id={item.title}
                  filterTextchange={this.filter}
                  filters={this.state.filters}
                  ftype={item.filterType}
                />
              </div>
            )}
          </th>
        );
      }),
    });
  }

  render() {
    return (
      // <Card className='border-1'>

      <thead className="shadow p-2 bg-white table-border">
        {this.props.headers.map((item) => {
          return (
            <th
              className="headerTextColor test"
              key={item.title}
              style={
                item.display ? {
                  background: "#FFF"
                } : { display: "none" }
                
              }
            >
              <div style={{
                marginLeft: 
                item.displayName === "Tax ID"
                  ? "4px" 
                  : item.displayName === "NPI"
                  ? "4px"
                  : item.displayName === "Sub ID"
                  ? "4px"
                  : item.displayName === "Member Name"
                  ? "4px"
                  : item.displayName === "Net Pay Amt ($)"
                  ? "5px"
                  : item.displayName === "Total Charges($)"
                  ? "5px"
                  : item.displayName === "Claim Status"
                  ? "4px"
                  : item.displayName === "Claim Type"
                  ? "4px"
                  : "0px",
              }}>{item.displayName}</div>
              <div>
                <img
                  src={tableSort}
                  style={{
                    cursor: "pointer",
                    marginTop:
                      item.displayName === "Tax ID"
                        ? "0px"
                        : item.displayName === "NPI"
                        ? "0px"
                        : item.displayName === "Sub ID"
                        ? "0px"
                        : item.displayName === "DOS From"
                        ? "0px"
                        : item.displayName === "DOS To"
                        ? "0px"
                        : item.displayName === "Claim Type"
                        ? "0px"
                        : "-12px",
                    marginBottom:
                      item.displayName === "Tax ID"
                        ? "-12px"
                        : item.displayName === "NPI"
                        ? "-12px"
                        : item.displayName === "Sub ID"
                        ? "-12px"
                        : item.displayName === "DOS From"
                        ? "-12px"
                        : item.displayName === "DOS To"
                        ? "-12px"
                        : item.displayName === "Claim Type"
                        ? "-12px"
                        : "0px"
                  }}
                  onClick={() => this.tableSort(item.title)}
                />
              </div>
              {this.props.filtertext === "ClaimsTable" && (
                <div  id="claim_id" className="mt-1" style={{marginTop:"1erm"}}>
                  <FilterSearchText
                    setField={item.displayName === "Claim Number" ? this.props.setFields.Claims : ""}
                    id={item.title}
                    filterTextchange={this.filter}
                    filters={this.state.filters}
                    ftype={item.filterType}
                  />
                </div>
              )}
            </th>
          );
        })}
      </thead>
      // </Card>
    );
  }
}
